import React from "react"
import PropTypes from "prop-types"
import { StyledField } from "./styles"

const DateField = ({ handleInputChange, ...rest }) => {
  const { name, value, min, max, placeholder } = rest
  const onChange = (value) => {
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }
  const selected = value ? new Date(value) : ""
  const minDate = min ? new Date(min) : ""
  const maxDate = max ? new Date(max) : ""

  return (
    <StyledField
      onChange={(date) => onChange(date)}
      selected={selected}
      dateFormat="dd MMMM yyyy"
      minDate={minDate}
      maxDate={maxDate}
      showYearDropdown
      scrollableYearDropdown
      showMonthDropdown
      useShortMonthInDropdown
      withPortal
      placeholder={placeholder}
      {...rest}
    />
  )
}

DateField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  invalid: PropTypes.bool
}

DateField.defaultProps = {
  handleInputChange: undefined,
  placeholder: "",
  invalid: false
}

export default DateField
